const CUSTOMER_SUPPORT_VISITED = "gtm-customer-support-visited";
const PREBUILD_SHOW_SPECS = "gtm-prebuild-show-specs";
const CUSTOMER_REVIEWS_CLICKS = "gtm-customer-reviews-clicks";
const PREBUILD_VISITED = "gtm-last-prebuild-visited";
const PREBUILD_NAMES_BY_PATH = new Map([
	["/h1-mini-pc", "NZXT H1 Mini PC"],
	["/creator-pc", "NZXT Creator PC"],
	["/streaming-pc", "NZXT Streaming PC"],
	["/starter-series:1", "The Starter"],
	["/starter-series?type=starter", "The Starter"],
	["/starter-series:2", "Starter Plus"],
	["/starter-series?type=starter-plus", "Starter Plus"],
	["/starter-series:3", "Starter Pro"],
	["/starter-series?type=starter-pro", "Starter Pro"]
]);
const CART_TOTAL_CONFIGURATOR = "gtm-cart-total-configurator";

// this is used in index.ejs gtm dataLayer
// to know if a datalayer variable is being tracked
const saveTrackingForVisitors = (trackingKey, value) => {
	sessionStorage.setItem(trackingKey, value);
};

const saveTrackingForUsers = (trackingKey, value) => {
	const userLogged = Cookies.get("cookies_id");
	if (userLogged) {
		localStorage.setItem(`${trackingKey}-user`, userLogged);
		localStorage.setItem(`${trackingKey}`, value);
	}
	return userLogged;
};

const saveTrackingInStorage = (trackingKey, value) => {
	const savedForUser = saveTrackingForUsers(trackingKey, value);

	if (!savedForUser) {
		saveTrackingForVisitors(trackingKey, value);
	}
};

const removeTrackingFromStorage = trackingKey => {
	localStorage.removeItem(trackingKey);
	localStorage.removeItem(`${trackingKey}-user`);
	sessionStorage.removeItem(trackingKey);
};

export const gtmSaveCartTotal = total => {
	const currentSessionDraft = window.localStorage.getItem("session-draft") || "";
	const cart = JSON.parse(window.localStorage.getItem(CART_TOTAL_CONFIGURATOR) || "{}");
	cart.sessionDraft = currentSessionDraft;
	cart.buildTotal = total;
	window.localStorage.setItem(CART_TOTAL_CONFIGURATOR, JSON.stringify(cart));
};


export const gtmMap = {
	prebuildSeriesToProduct(build) {
		return {
			id: build.sku,
			name: build.name,
			price: build.price,
			category: "prebuilds",
			variant: build.colors[0],
			quantity: 1
		};
	},
	starterSeriesAccessoryToProduct(
		category,
		prebuildType,
		variant = "colors"
	) {
		return {
			id: category.sku,
			name: category.name,
			price: category.price,
			category: `prebuilds/${prebuildType}/accessories/${
				category.productModule.marketing_name
			}`,
			variant: category[variant],
			quantity: category.quantity
		};
	},
	starterSeriesPrebuildToProduct(build = {}, cartCase = {}) {
		const shopifyProducts = JSON.parse(build.shopify_product || "{}");
		const selectedVariant = (shopifyProducts.variants || []).find(
			variant => variant.caseVariantId == cartCase.id
		);

		if (!selectedVariant || !selectedVariant.sku) {
			return {};
		}

		return {
			id: selectedVariant.sku,
			name: build.name,
			price: build.price,
			category: "prebuilds",
			variant: cartCase.colors,
			quantity: 1
		};
	}
};

export const gtmTrack = {
	userSession(countryCode) {
		const countriesAllowTracking = ["US", "CA", "DO"];

		if (countriesAllowTracking.includes(countryCode)) {
			window.dataLayer.push({
				userId: Cookies.get("id")
			});
		}
	},
	userCheckout() {
		window.dataLayer.push({
			userCheckout: true
		});
	},
	userCheckoutCanceled() {
		window.dataLayer.push({
			userCheckout: false
		});
	},
	configuratorGames([firstGame, secondGame, thirdGame]) {
		window.dataLayer.push({
			configGame1: firstGame,
			configGame2: secondGame,
			configGame3: thirdGame
		});
	},
	financeInquires() {
		window.dataLayer.push({
			userFinancing: true
		});
	},
	configuratorBudget(budget) {
		window.dataLayer.push({
			configBudget: budget
		});
	},
	skipConfigStep(skipped) {
		window.dataLayer.push({
			configStepskip: skipped
		});
	},
	// this should be used if no custom configuration is done
	selectedProcessor(brand) {
		window.dataLayer.push({
			configProcessorType: brand
		});
	},
	visitSupportPage() {
		saveTrackingInStorage(CUSTOMER_SUPPORT_VISITED, true);
		window.dataLayer.push({
			customerSupport: true
		});
	},
	prebuildShowSpecs() {
		saveTrackingInStorage(PREBUILD_SHOW_SPECS, true);
		window.dataLayer.push({
			showSpecs: true
		});
	},
	customReviewsClick() {
		saveTrackingInStorage(CUSTOMER_REVIEWS_CLICKS, true);
		window.dataLayer.push({
			customerReviews: true
		});
	},
	prebuildVisited(prebuild) {
		const saved = saveTrackingForUsers(PREBUILD_VISITED, prebuild);
		if (saved) {
			window.dataLayer.push({
				userPrebuiltView: prebuild
			});
		}
	},
	prebuildVisitedByRoute(route) {
		const { fullPath } = route;
		const STARTER_SERIES_ROUTE = "/starter-series";

		if (!(fullPath.includes(STARTER_SERIES_ROUTE) || PREBUILD_NAMES_BY_PATH.has(fullPath))) {
			return;
		}

		let prebuild = PREBUILD_NAMES_BY_PATH.get(fullPath) || "";

		if (fullPath === STARTER_SERIES_ROUTE) {
			const starterPrebuildID = window.localStorage.getItem("starter_prebuild_id") || 1;
			prebuild = PREBUILD_NAMES_BY_PATH.get(`${STARTER_SERIES_ROUTE}:${starterPrebuildID}`) || "";
		}

		this.prebuildVisited(prebuild);
	},
	buildConfiguration(activeBuild) {
		const generalTrackingParts = {
			configCaseSKU: activeBuild.case.sku,
			configCaseColor: activeBuild.case.colors,
			configCoolSKU: activeBuild.cpuCooler.sku,
			configMOBOSKU: activeBuild.motherboard.sku,
			configGPUSKU: activeBuild.gpu.sku,
			configCPUSKU: activeBuild.cpu.sku,
			configPSUSKU: activeBuild.powerSupply.sku,
			configRAMSKU: activeBuild.ram.sku,
			configRAMQuantity: activeBuild.ram.quantity,
			configSoftware: activeBuild.software.sku
		};

		const getTrackingParts = (parts, props, primaryProp) => {
			return parts.reduce((trackingParts, part, index) => {
				const hasPrimaryProp = primaryProp ? part[primaryProp] : true;
				if (hasPrimaryProp) {
					const position = index + 1;
					for (const prop in props) {
						const trackingName = `${props[prop]}#${position}`;
						trackingParts[trackingName] = part[prop];
					}
				}
				return trackingParts;
			}, {});
		};

		const rgbTrackingParts = getTrackingParts(activeBuild.rgbs, { sku: "configRGB" }, "sku");
		const storage = [...activeBuild.ssd, ...activeBuild.hdd];
		const storageTrackingParts = getTrackingParts(storage, { sku: "configStorageSKU", quantity: "configStorageQuantity" }, "sku");

		const trackingParts = { ...generalTrackingParts, ...rgbTrackingParts, ...storageTrackingParts };

		window.dataLayer.push(trackingParts);
	},
	cartTotal(cartTotal) {
		window.dataLayer.push({
			cartTotal: window.accounting.toFixed(cartTotal, 2)
		});
	},
	cartTotalByRoute(toRoute, fromRoute) {
		const cart = JSON.parse(window.localStorage.getItem(CART_TOTAL_CONFIGURATOR) || "{}");
		const validRoutes = ["step3", "step4", "step4-mobile"];
		if (toRoute.name === "step5" && validRoutes.includes(fromRoute.name) && cart.buildTotal) {
			gtmTrack.cartTotal(cart.buildTotal);
		}
	},
	cartPrebuild(prebuild = {}) {
		let gtmVariables = {
			preBuilt: Boolean(prebuild.pcSKU)
		};

		if (prebuild.pcSKU) {
			gtmVariables = { ...gtmVariables, ...prebuild };
		}

		window.dataLayer.push(gtmVariables);
	}
};

export const gtmUntrack = {
	userSession() {
		window.dataLayer.push({
			userId: undefined
		});
	},
	userCheckout() {
		window.dataLayer.push({
			userCheckout: undefined
		});
	},
	sessionVariables() {
		removeTrackingFromStorage(PREBUILD_SHOW_SPECS);
		removeTrackingFromStorage(CUSTOMER_SUPPORT_VISITED);
		removeTrackingFromStorage(CUSTOMER_REVIEWS_CLICKS);
		removeTrackingFromStorage(PREBUILD_VISITED);
		window.dataLayer.push({
			customerSupport: false,
			showSpecs: false,
			customerReviews: false,
			prebuildVisited: undefined
		});
	}
};

export const gtmTrigger = {
	addToCart(products, triggerLocation, currencyCode = "USD") {
		window.dataLayer.push({
			event: "eec.add",
			section: triggerLocation,
			ecommerce: {
				currencyCode,
				add: {
					products
				}
			}
		});
	},
	showSpecs(product) {
		window.dataLayer.push({
			event: "showSpecs",
			product
		});
	},
	checkoutClick(triggerLocation) {
		window.dataLayer.push({
			event: "clickCheckoutButton",
			section: triggerLocation
		});
	},
	quotedPaymentClick(product, triggerLocation) {
		window.dataLayer.push({
			event: "clickAffirm",
			section: triggerLocation,
			product
		});
	}
};
